import { styled } from '@mui/material/styles';
import { COLOR, TRANSPARENT_COLOR } from '@src/styles/color';

export const StyledProjectInput = styled('div')`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 214px));
  width: 100%;
  max-width: 2000px;
  gap: 16px;
  margin-bottom: 8px;
  margin-top: 8px;
`;

export const StyledProjectInputItem = styled('div')`
  cursor: pointer;
  height: 152px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  &:hover {
    .img-wrapper {
      background-color: ${TRANSPARENT_COLOR.dark};
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    }
  }

  .img-wrapper {
    background-color: ${COLOR.background};
    border-radius: 16px;
    width: 100%;
    height: 100%;
    margin-bottom: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .card-title {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    letter-spacing: -0.4px;
    color: #000000;
  }
`;
